import { ROUTES } from '@/shared/config';
import { Navigate } from 'react-router-dom';
import type { RoutePathDefinition } from '../../types';

export const errorSectionRoutes: RoutePathDefinition[] = [
  {
    path: 'forbidden',
    element: <Navigate to={ROUTES.LOGIN} replace state={{ statusCode: 401 }} />
  },
  {
    path: 'not-found',
    element: <Navigate to={ROUTES.LOGIN} replace state={{ statusCode: 404 }} />
  },
  {
    path: '*',
    element: <Navigate to={ROUTES.ERROR.NOT_FOUND} replace />
  }
];
